<div class="password-confirm-wrapper">
    <div class="form-content">
        <div class="top-greeting">
            Password Reset Initiated <br>
            <div style="font-size: 16px;"> You will receive an email with the link which will remain as active 30 minute. </div>
        </div>
        <div style="margin-bottom: 20px;">
            Remember Your Password? <br> <br>
            <a href="/#/login" class="reset-password-btn">Return to Login</a>
        </div>
    </div>
</div>
